/* KYME ACTIVE - collection grid behaviour */
(function () {
  'use strict';

  var SWATCHES = {
    black: '#141414',
    almond: '#cbb9ab',
    navy: '#1f2d5c',
    ruby: '#a41f2b',
    plum: '#6e2246',
    mist: '#8fa5b6',
    blush: '#e8c4cb',
    petal: '#e8c4cb',
    pink: '#e8c4cb',
    bone: '#efe9e1',
    sage: '#9aa88f',
    espresso: '#3b2a23',
    white: '#f7f5f2'
  };

  function hexFor(color) {
    if (color.hex) return color.hex;
    var key = (color.name || '').toLowerCase().trim();
    return SWATCHES[key] || '#d8d2ca';
  }

  var quickAddPanels = [];

  function closeQuickAdds(except) {
    quickAddPanels.forEach(function (entry) {
      if (entry.toggle === except) return;
      entry.toggle.setAttribute('aria-expanded', 'false');
      entry.panel.setAttribute('hidden', '');
    });
  }

  function initCard(card) {
    var dataEl = card.querySelector('[data-kyme-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var colors = (data.colors || []).filter(function (c) {
      return c && c.sizes && c.sizes.length;
    });
    if (!colors.length) return;

    var img = card.querySelector('[data-kyme-image]');
    var nameEl = card.querySelector('[data-kyme-color-name]');
    var swatchWrap = card.querySelector('[data-kyme-swatches]');
    var sizesWrap = card.querySelector('[data-kyme-sizes]');
    var quickBtn = card.querySelector('[data-kyme-quick]');
    var links = card.querySelectorAll('[data-kyme-link]');
    var current = 0;

    if (!quickBtn || !sizesWrap || !swatchWrap) return;

    function paintSizes() {
      var color = colors[current];
      sizesWrap.innerHTML = '';
      color.sizes.forEach(function (size) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'kyme-size';
        b.textContent = size.name;
        b.disabled = !size.available;
        b.setAttribute('data-variant-id', size.id);
        b.addEventListener('click', function () {
          addToCart(b, size.id, data.title, color.name);
        });
        sizesWrap.appendChild(b);
      });
    }

    function select(index) {
      current = index;
      var color = colors[index];

      if (img && color.image) img.src = color.image;
      if (nameEl) nameEl.textContent = colors.length > 1 ? color.name : '';
      links.forEach(function (a) {
        if (color.url) a.href = color.url;
      });

      swatchWrap.querySelectorAll('.kyme-swatch').forEach(function (s, i) {
        s.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });

      paintSizes();
    }

    if (colors.length > 1) {
      colors.forEach(function (color, i) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'kyme-swatch';
        b.setAttribute('aria-pressed', i === 0 ? 'true' : 'false');
        b.setAttribute('aria-label', color.name);
        b.title = color.name;
        if (color.swatchImage) {
          b.style.backgroundImage = 'url(' + color.swatchImage + ')';
        } else {
          b.style.background = hexFor(color);
        }
        b.addEventListener('click', function () {
          select(i);
        });
        swatchWrap.appendChild(b);
      });
    }

    quickAddPanels.push({ toggle: quickBtn, panel: sizesWrap });

    quickBtn.addEventListener('click', function () {
      var open = sizesWrap.hasAttribute('hidden');
      closeQuickAdds(quickBtn);
      if (open) {
        sizesWrap.removeAttribute('hidden');
      } else {
        sizesWrap.setAttribute('hidden', '');
      }
      quickBtn.setAttribute('aria-expanded', String(open));
    });

    select(0);
  }

  function addToCart(button, variantId, title, colorName) {
    button.classList.add('is-busy');
    button.disabled = true;

    var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    var cartDrawer = document.querySelector('cart-drawer');
    var body = { items: [{ id: Number(variantId), quantity: 1 }] };

    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      body.sections = cartDrawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }

    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return r.json();
      })
      .then(function (response) {
        var rendered = false;
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          try {
            cartDrawer.renderContents(response);
            rendered = true;
          } catch (err) {
            console.error('[kyme] cart-drawer renderContents failed; item was added to cart.', err);
          }
        }
        if (!rendered) toast('Added - ' + title + (colorName ? ', ' + colorName : ''));
        refreshCartCount();
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
      })
      .catch(function (err) {
        console.error('[kyme] add to cart failed', err);
        toast('That size just sold out. Try another.');
      })
      .finally(function () {
        button.classList.remove('is-busy');
        button.disabled = false;
      });
  }

  function refreshCartCount() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document
          .querySelectorAll('[data-cart-count], .cart-count, .site-header__cart-count, .cart-link__bubble-num, #CartCount')
          .forEach(function (el) {
            el.textContent = cart.item_count;
            el.classList.remove('hide', 'hidden');
          });
      })
      .catch(function () {});
  }

  var toastTimer;
  function toast(message) {
    var el = document.querySelector('[data-kyme-toast]');
    if (!el) return;
    el.querySelector('[data-kyme-toast-text]').textContent = message;
    el.removeAttribute('hidden');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      el.setAttribute('hidden', '');
    }, 4000);
  }

  function initCollection(root) {
    var grid = root.querySelector('[data-kyme-grid]');
    if (!grid) return;

    var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-kyme-card]'));
    var countEl = root.querySelector('[data-kyme-count]');
    var noneEl = root.querySelector('[data-kyme-none]');
    var state = { line: '*', cat: '*' };

    function apply() {
      var shown = 0;
      cards.forEach(function (card) {
        var okLine = state.line === '*' || card.dataset.line === state.line;
        var okCat = state.cat === '*' || card.dataset.cat === state.cat;
        if (okLine && okCat) {
          card.removeAttribute('hidden');
          shown++;
        } else {
          card.setAttribute('hidden', '');
        }
      });
      if (countEl) countEl.textContent = shown + (shown === 1 ? ' piece' : ' pieces');
      if (noneEl) noneEl.hidden = shown !== 0;
    }

    function wire(selector, key) {
      root.querySelectorAll(selector).forEach(function (btn) {
        btn.addEventListener('click', function () {
          root.querySelectorAll(selector).forEach(function (b) { b.classList.remove('is-active'); });
          btn.classList.add('is-active');
          state[key] = btn.getAttribute(key === 'line' ? 'data-filter-line' : 'data-filter-cat');
          apply();
        });
      });
    }

    wire('[data-filter-line]', 'line');
    wire('[data-filter-cat]', 'cat');

    var sortEl = root.querySelector('[data-kyme-sort]');
    if (sortEl) {
      sortEl.addEventListener('change', function () {
        var mode = sortEl.value;
        var sorted = cards.slice().sort(function (a, b) {
          if (mode === 'price-asc') return a.dataset.price - b.dataset.price;
          if (mode === 'price-desc') return b.dataset.price - a.dataset.price;
          if (mode === 'title-asc') return a.dataset.title.localeCompare(b.dataset.title);
          return a.dataset.position - b.dataset.position;
        });
        sorted.forEach(function (card) { grid.appendChild(card); });
      });
    }

    cards.forEach(initCard);
    apply();
  }

  function boot() {
    document.querySelectorAll('[data-kyme-collection]').forEach(initCollection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
